var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "right-menu spaceLeft" },
      [
        _c(
          "div",
          { staticClass: "badge-box right-menu_svg" },
          [
            _c("svg-icon", {
              attrs: { "icon-class": "tn-bill" },
              on: {
                click: function ($event) {
                  return _vm.$router.push("/messages/index")
                },
              },
            }),
            _vm._v(" "),
            _vm.$store.getters.mssageUnreadCount > 0
              ? _c("div", { staticClass: "badge" })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("metaMaskInit"),
        _vm._v(" "),
        _c("svg-icon", {
          staticClass: "right-menu_svg",
          attrs: { "icon-class": "tn-logout" },
          on: { click: _vm.logout },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }